import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const links = [
  { label: "Studio", href: "#manifesto" },
  { label: "What We Do", href: "#what-we-do" },
  { label: "The Work", href: "#work" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "bg-[#0a0705]/70 backdrop-blur-md border-b border-[#2a1f17]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5 md:px-10">
        <a
          href="#top"
          data-testid="nav-logo"
          className="group flex items-center gap-3"
        >
          <img
            src="https://customer-assets-jt897jd0.emergentagent.net/job_web-launch-501/artifacts/2wiz6vr6_Icon.webp"
            alt="Butterhoney Labs"
            className="h-14 w-14 object-contain drop-shadow-[0_0_18px_rgba(217,144,54,0.35)] transition-transform duration-700 group-hover:rotate-[8deg] md:h-16 md:w-16"
          />
          <span className="font-display text-[13px] font-bold uppercase tracking-[0.28em] text-[#f9f6f0]">
            Butter Honey<span className="text-[#d99036]">.</span>Labs
          </span>
        </a>

        <nav className="hidden items-center gap-9 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative overline text-[#a89f91] transition-colors duration-300 hover:text-[#f9f6f0]"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[#d99036] transition-transform duration-500 group-hover:scale-x-100" />
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta"
          className="group hidden items-center gap-2 border border-[#2a1f17] px-4 py-2 font-body text-[12px] uppercase tracking-[0.22em] text-[#f9f6f0] transition-colors duration-500 hover:border-[#d99036] hover:text-[#d99036] md:inline-flex"
        >
          <span>Book a Call</span>
          <span
            aria-hidden
            className="inline-block transition-transform duration-500 group-hover:translate-x-1"
          >
            →
          </span>
        </a>
      </div>
    </motion.header>
  );
}
